module.exports = __webpack_public_path__ + "img/icon_yt.svg?c50402c02205ed8fe9da84c65c7b2d71";